import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

import analyticService from '../../../services/analytics';

import TopArticles from './top-articles';
import EarningsGraph from './earnings-graph';
import TotalsHero from './totals-hero';

const MerchantDashboard = ({ match }) => {
  const merchId = match.params.merchantId;

  useEffect(() => {
    analyticService.trackEvent('Merchant Dashboard', 'Load', null);
  }, []);

  return (
    <div className="merchant-dashboard">
      <TotalsHero merchId={merchId} />
      <EarningsGraph merchId={merchId} />
      <TopArticles merchId={merchId} />
    </div>
  );
};

export default withRouter(MerchantDashboard);
